import useFormatMessage from 'hooks/useFormatMessage';
import useToast, { TOASTTYPES } from 'hooks/useToast';

export default function useAnswerQuestion() {
  const toast = useToast();
  const t = useFormatMessage();

  const mutateAsync = async (question, answers) => {
    const { questionId, questionType } = question || {};

    const data =
      questionType !== 'OPEN'
        ? {
            v2AnswerQuestion: {
              questionAnswersMultipleChoice: answers,
              questionId: `${questionId}`,
              teacherFeedback: null,
              type: questionType,
              userAnswers: null,
            },
          }
        : { v2AnswerQuestion: null };

    toast(TOASTTYPES.UPDATESUCCESS, {
      str: t('global.ANSWER.singular'),
      toastId: 'createAnswer',
    });

    return data;
  };

  return {
    isLoading: false,
    mutateAsync,
  };
}
